module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0036.jpg?v=c66b3ee7";